<button
	tlkButton
	size="m"
	variant="primary"
	class="rx-intuitive-remove-bridge-button"
	[disabled]="disabled"
	(click)="onClicked()"
>
	<tlk-delete-icon class="tlk-icon_size_m"/>
	<span class="rx-intuitive-remove-bridge-button__label">{{ 'ToothEditor.RemoveFromBridge' | translate }}</span>
</button>